var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveExam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-groups_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups_1",
    "data-name": "groups \\u2013 1",
    clipPath: "url(#clip-groups_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    transform: "translate(1 1)",
    fill: "rgba(238,71,63,0.15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    transform: "translate(113 113)",
    fill: "#fc645d",
    stroke: "#fff",
    strokeWidth: 25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 143.5,
    r: 143.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.5,
    cy: 143.5,
    r: 131,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveExam);
export default __webpack_public_path__ + "static/media/live-exam.22bb2f56.svg";
export { ForwardRef as ReactComponent };